import React from 'react'
import BaseModal from '../BaseModal/BaseModal'
import styles from './Modal.module.scss'

export interface ModalProps {
  children: JSX.Element | JSX.Element[]
  open: boolean
  toggle?: () => void
  className?: string
}

export interface PartOptions {
  header: JSX.Element | null
  body: JSX.Element | null
  footer: JSX.Element | null
}

const Header = ({ children }) => {
  return <header id='dialog-title'>{children}</header>
}

const Body = ({ children }) => {
  return <section className={styles.body}>{children}</section>
}

const Footer = ({ children }) => {
  return <footer className={styles.footer}>{children}</footer>
}

const Modal = ({ children, toggle, open, className }: ModalProps) => {
  const parts: PartOptions = {
    header: null,
    body: null,
    footer: null,
  }

  React.Children.forEach(children, child => {
    switch (child?.type) {
      case Header: {
        parts.header = child
        break
      }
      case Body: {
        parts.body = child
        break
      }
      case Footer: {
        parts.footer = child
        break
      }
      default:
        break
    }
  })

  return (
    <BaseModal open={open} toggle={toggle} className={className}>
      {parts.header}
      {parts.body}
      {parts.footer}
    </BaseModal>
  )
}

Modal.Header = Header
Modal.Body = Body
Modal.Footer = Footer

export default Modal
